import { Component } from '@angular/core';

@Component({
    selector: 'app-ffa-administration',
    templateUrl: './ffa-administration.component.html',
    styleUrl: './ffa-administration.component.scss',
})
export class FfaAdministrationComponent {}
